// pdfmake
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ContentCanvas, TDocumentDefinitions } from 'pdfmake/interfaces';

// @ts-ignore
pdfMake.addVirtualFileSystem(pdfFonts);

export const createPdf = (docDefinition: TDocumentDefinitions) => {
  return pdfMake.createPdf(docDefinition);
};

export const background = (color: string = '#ffffff') => {
  const canvas: ContentCanvas = {
    canvas: [
      {
        type: 'rect',
        x: 0,
        y: 0,
        w: 595.28,
        h: 841.89,
        color: color,
      },
    ],
  };
  return canvas;
};

export const pageSize = {
  width: 595.28,
  height: 841.89,
};
